export const ANALYTICS_AS_DATA = {
  AS_UID: "as-uid",
  AS_DID: "as-did",
  AS_UA: "as-ua",
  AS_ET: "as-et",
  AS_SI: "as-si",
  AS_E: "as-e",
  AS_WC: "as-wc",
  AS_TZ: "as-tz",
  AS_ST: "as-st",
  AS_PT: "as-pt",
  AS_PI: "as-pi",
  AS_AV: "as-av",
  AS_BV: "as-bv",
  AS_GEO: "as-geo",
  AS_HD: "as-hd",
  AS_OS: "as-os",
  AS_PID: "as-pid",
};

export const ANALYTICS_VS_DATA = {
  VS_ET: "vs-et",
  VS_VSI: "vs-vsi",
  VS_NT: "vs-nt",
  VS_CS: "vs-cs",
  VS_DR: "vs-dr",
  VS_E: "vs-e",
  VS_WC: "vs-wc",
  VS_VT: "vs-vt",
  VS_PN: "vs-pn",
  VS_PV: "vs-pv",
  VS_CF: "vs-cf",
  VS_DRM: "vs-drm",
  VS_CODEC: "vs-codec",
  VS_CDN: "vs-cdn",
  VS_SCE: "vs-sce",
  VS_CID: "vs-cid",
  VS_DP: "vs-dp",
  VS_PR: "vs-pr",
  VS_SBR: "vs-sbr",
  VS_ST: "vs-st",
  VS_PT: "vs-pt",
  VS_PID: "vs-pid",
  VS_AV: "vs-av",
  VS_BV: "vs-bv",
  VS_GEO: "vs-geo",
  VS_HD: "vs-hd",
  VS_OS: "vs-os",
  VS_NT: "vs-nt",
  VS_CS: "vs-cs",
  VS_TTFB: "vs-ttfb",
  VS_CT: "vs-ct",
  VS_VR: "vs-vr",
  VS_POS: "vs-pos",
  VS_VEC: "vs-vec",
  VS_VSM: "vs-vsm",
  VS_SUM: "vs-sum",
  VS_VLEN: "vs-vlen",
  VS_WAT: "vs-wat",
  VS_SEQ: "vs-seq",
};

export const ANALYTICS_VSH_DATA = {
  VSH_E: "vsh-e",
  VSH_WC: "vsh-wc",
  VSH_WST: "vsh-wst",
  VSH_WET: "vsh-wet",
  VSH_SP: "vsh-sp",
  VSH_EP: "vsh-ep",
  VSH_DUR: "vsh-dur",
  VSH_DF: "vsh-df",
  VSH_BH: "vsh-bh",
  VSH_NA: "vsh-na",
  VSH_NDS: "vsh-nds",
  VSH_CT: "vsh-ct",
  VSH_VR: "vsh-vr",
  VSH_VPS: "vsh-vps",
  VSH_LL: "vsh-ll",
  VSH_NC: "vsh-nc",
  VSH_HSEQ: "vsh-hseq",
};
export const ANALYTICS_EVENT_DATA = {
  EVENT_E: "e",
  EVENT_WC: "wc",
  EVENT_TZ: "tz",
  EVENT_FTL: "ftl",
  EVENT_EC: "ec",
  EVENT_EM: "em",
  EVENT_EXTR: "extr",
  EVENT_VEC: "vec",
  EVENT_VSUM: "vsum",
};
export const ANALYTICS_CUSTOMTAG_DATA = {
  CUSTOMTAG_COLOUR: "colour",
};
export const ANALYTICS_API_NAME = {
  APP_SESSION_START: "App-Session-Start",
  VIDEO_SESSION_START: "Video-Session-Start",
  VIDEO_ATTEMPT: "Video-Attempt",
  VIDEO_PLAY: "Video-Play",
  VIDEO_SESSION_HEARTBEAT: "Video-Session-Heartbeat",
  VIDEO_ERROR: "Video-Error",
  VIDEO_END: "Video-End",
  VIDEO_SESSION_END: "Video-Session-End",
  APP_SESSION_END: "App-Session-End",
  // Ads api url
  ADS_ATTEMPT: "Ads-attempt",
  ADS_END: "Ads-End",
  ADS_ERROR: "Ads-Error",
  ADS_HEARTBEAT: "Ads-Heartbeat",
  ADS_PLAY: "Ads-Play",
  APP_FORE_GROUND: "App-Fore-Grounded",
  APP_BACK_GROUND: "App-Back-Grounded",
  VIDEO_SESSION_PULSE: "Video-Session-Pulse",
};
export const EVENT_MAPPING = {
  app_user_id: "as-uid",
  app_device_id: "as-did",
  app_user_agent: "as-ua",
  app_event_type: "as-et",
  app_session_id: "as-si",
  // app_event: "as-e",
  app_wall_clock: "as-wc",
  app_time_zone: "as-tz",
  app_subscribe_type: "as-st",
  app_platform_type: "as-pt",
  app_partner_id: "as-pid",
  app_version: "as-av",
  app_build_version: "as-bv",
  app_geo_location: "as-geo",
  app_hardware: "as-hd",
  app_operating_system: "as-os",

  app_profile_id: "as-profid",
  app_ppid: "as-ppid",
  app_sliv_profile_id: "as-liv_id",
  app_user_age: "as-age",
  app_user_gender: "as-gen",

  video_event_type: "vs-et",
  video_session_id: "vs-vsi",
  video_network_type: "vs-nt",
  video_connection_speed: "vs-cs",
  video_device_resolution: "vs-dr",
  video_event: "vs-e",
  video_wall_clock: "vs-wc",
  video_video_type: "vs-vt",
  video_player_name: "vs-pn",
  video_player_version: "vs-pv",
  video_content_format: "vs-cf",
  video_drm: "vs-drm",
  video_codec: "vs-codec",
  video_cdn: "vs-cdn",
  video_session_classifier_experiment_id: "vs-sce",
  video_content_id: "vs-cid",
  video_delivery_protocol: "vs-dp",
  video_playing_rate: "vs-pr",
  video_starting_bitrate: "vs-sbr",
  video_session_type: "vs-st",
  video_platform_type: "vs-pt",
  video_partner_id: "vs-pid",
  video_application_version: "vs-av",
  video_build_version: "vs-bv",
  video_geo_location: "vs-geo",
  video_hardware: "vs-hd",
  video_operating_system: "vs-os",
  video_time_to_first_byte: "vs-ttfb",
  video_connect_time: "vs-ct",
  video_resolution: "vs-vr",
  video_position: "vs-pos",
  video_end_codec: "vs-vec",
  video_streaming_mode: "vs-vsm",
  video_summary: "vs-sum",
  video_length: "vs-vlen",
  video_wat: "vs-wat",
  video_sequence: "vs-seq",
  // NEW KEYS ADDED
  video_current_bitrate: "vs-cbr",
  video_audio_language: "vs-al",
  video_subtitle_language: "vs-sl",
  video_streaming_host: "vs-sh",
  video_content_prefetch: "vs-cp",
  video_binge: "vs-bng",
  video_18plus: "vs-eplus",
  video_session_start_time: "vs-sst",
  from_audio_language: "fl",
  to_audio_language: "tl",
  from_subtitle_language: "fl",
  to_subtitle_language: "tl",
  video_session_watch_time_duration: "vs-wtd",
  video_increment_buffer_time_duration: "vs-bfd",
  normalized_watch_time: "vs-nwtd",
  video_monetizable_video_views : "vs-mvv",

  event_event_type: "e",
  event_wall_clock: "wc",
  event_time_zone: "tz",
  event_ftl: "ftl",
  event_error_code: "ec",
  event_error_message: "em",
  event_exception: "extr",
  event_video_end_code: "vec",
  event_video_session_summary: "vsum",
  event_start_position: "sp",
  event_end_position: "ep",
  event_duration: "dur",
  // event_data_list: "",
  event_from_bitrate: "fb",
  event_to_bitrate: "tb",
  event_increment_number: "df",
  event_buffer_health: "bh",
  event_network_activity: "na",
  event_video_resolution: "vr",
  event_viewport_size: "vps",
  event_live_latency: "ll",
  event_network_connectivity: "nc",
  customtag_colour: "colour",
  custom_tags: "custom_tags",
  event_net_download_speed: "nds",
  event_content_type: "ct",
  network_bandwidth_bucket: "nwb",
  current_bitrate: "cbr",
  event_current_playback_rate: "pbr",
  event_former_playback_rate: "fpbr",
  event_playing_state: "pls",
  event_admrk_id: "admrk_id",

  heart_beat_events: "event",

  //heartbeat event name for player

  heart_beat_event_seek: "Seek",
  heart_beat_event_buffer: "Buffer",
  heart_beat_event_pause: "pause",
  heart_beat_event_resume: "resume",
  heart_beat_event_upshift: "upshift",
  heart_beat_event_downshift: "downshift",
  heart_beat_event_dropped_frames: "dropped-frames",
  heart_beat_event_buffer_health: "buffer-health",
  heart_beat_event_network_activity: "network-activity",
  heart_beat_event_video_resize: "video-resize",
  heart_beat_event_golive: "golive",
  heart_beat_event_network_change: "network-change",
  heart_beat_event_audio_language: "audio-language",
  heart_beat_event_subtitle_language: "subtitle-language",
  heart_beat_event_buffer_start: "BufferStart",
  heart_beat_event_buffer_end: "BufferEnd",
  heart_beat_network_bandwidth: "network-bandwidth",
  heart_beat_speed_change: "speed-change",
  heart_beat_live_to_ad: "live_to_ad",
  heart_beat_live_to_ad_to_live: "live_to_ad_to_live",
  heart_beat_ad_to_live: "ad_to_live",

  // New key for Ad
  ads_event_type: "ads-et",
  ads_session_id: "ads-sid",
  ads_campaign_id: "ads-camid",
  ads_advertiser_id: "ads-advid",
  ads_current_ad_count: "ads-curc",
  ads_configured_ad_count: "ads-conc",
  ads_position: "ads-pos",
  ads_pod_position: "ads-pdpos", //ads-ppos replace to ads-pdpos
  ads_length_watched: "ads-wat",
  ads_length_duration: "ads-alen",
  ads_asset_name: "ads-an",
  ads_stream_url: "ads-surl",
  ads_technology: "ads-atec",
  ads_system: "ads-sys",
  ads_advertiser: "ads-adv",
  ads_creative_id: "ads-crid",
  ads_description: "ads-desc",
  ads_stitcher: "ads-st",
  ads_is_slate: "ads-isl",
  ads_media_file_api_framework: "ads-mfaf",
  ads_manager_name: "ads-am",
  ads_manager_version: "ads-amv",
  ads_first_ad_system: "ads-fas",
  ads_first_ad_id: "ads-faid",
  ads_first_creative_id: "ads-fcrid",
  ads_current_bitrate: "ads-cbr",
  ads_session_start_epoch_time: "ads-sst",

  ads_pod_ad_position: "ads-papos",
  ads_pod_max_ad_count: "ads-pacnt",
  ads_previous_pod: "ads-ppewc",
  ads_ad_buffer_duration: "ads-bfd",

  ads_cluster_id: "ads-clsid",
  ads_campaign_name: "ads-camnm",
  ads_watch_time_duration: "ads-wtd",
  ads_ABA_experiment_name: "ads-abaen",
  ads_ABA_experiment_variant_name: "ads-abaev",

  //heartbeat ads events key

  heart_beat_ads_event_ad_click: "AdClick",
  heart_beat_ads_event_ad_skip: "AdSkip",
  heart_beat_ads_event_ad_buffer: "AdBuffer",
  heart_beat_ads_event_ad_pause: "AdPause",
  heart_beat_ads_event_ad_resume: "AdResume",
  heart_beat_event_ad_click_url: "url",
  heart_beat_event_ad_buffer_dur: "dur",
  heart_beat_ads_event_ad_buffer_start: "AdBufferStart",
  heart_beat_ads_event_ad_buffer_end: "AdBufferEnd",

  // Pulse events for player
  pulse_event_name: "pulse",
  pulse_event_count_sequence: "vs-plscnt",
  pulse_start_steps: "pls_stp", // "VideoUrlFetch"
  pulse_micro_steps: "pls_mstp", //"RequestStart",
  pulse_player_state: "pls_plyrst", //"Buffering"
  pulse_player_retry: "pls_rty", // retry status
};

export const ANALYTICS_EVENT_NAME = {
  APP_APP_SESSION_START: "AppSessionStart",
  EVENT_APP_SESSION_START: "AppSessionStart",
  APP_APP_SESSION_END: "AppSessionEnd",
  EVENT_APP_SESSION_END: "AppSessionEnd",
  VIDEO_VIDEO_SESSION_ATTEMPT: "VideoAttempt",
  EVENT_VIDEO_SESSION_ATTEMPT: "Attempt",
  VIDEO_VIDEO_SESSION_VIDEOEND: "VideoEnd",
  EVENT_VIDEO_SESSION_VIDEOEND: "VideoEnd",
  VIDEO_VIDEO_SESSION_VIDEOERROR: "VideoError",
  EVENT_VIDEO_SESSION_VIDEOERROR: "VideoError",
  VIDEO_VIDEO_SESSION_VIDEOPLAY: "VideoPlay",
  EVENT_VIDEO_SESSION_VIDEOPLAY: "Play",
  VIDEO_VIDEO_SESSION_END: "VideoSessionEnd",
  EVENT_VIDEO_SESSION_END: "VideoSessionEnd",
  VIDEO_VIDEO_SESSION_VIDEOHEARTBEAT: "VideoHeartbeat",
  VIDEO_VIDEO_SESSION_START: "VideoSessionStart",
  EVENT_VIDEO_SESSION_START: "VideoSessionStart",
  VIDEO_APP_FORE_GROUND: "AppForegrounded",
  EVENT_APP_FORE_GROUND: "AppForegrounded",
  VIDEO_APP_BACK_GROUND: "AppBackgrounded",
  EVENT_APP_BACK_GROUND: "AppBackgrounded",
  VIDEO_VIDEO_SESSION_PULSE: "Pulse",

  // Ads event name
  ADS_AD_ATTEMPT: "AdAttempt",
  EVENT_ADS_AD_ATTEMPT: "AdAttempt",
  ADS_AD_END: "AdEnd",
  EVENT_ADS_AD_END: "AdEnd",
  ADS_AD_ERROR: "AdError",
  EVENT_ADS_AD_ERROR: "AdError",
  ADS_AD_HEARTBEAT: "AdHeartbeat",
  EVENT_ADS_AD_HEARTBEAT: "AdHeartbeat",
  ADS_AD_PLAY: "AdPlay",
  EVENT_ADS_AD_PLAY: "AdPlay",
};

// BEACON_BASE_URL: "https://dev-analytic.sonyliv.com/beacon",

export const ANALYTICS_DEFAULT_CONFIG = {
  BEACON_BASE_URL: "https://api-godavari.sonyliv.com/beacon",
  GODAVARI_AD_HEARTBEAT_INTERVAL: 10000,
  GODAVARI_ENABLED: true,
  GODAVARI_ERROR_RETRYINTERVAL: 30000,
  GODAVARI_HEARTBEAT_INTERVAL: 40000,
};

export const PLATFORM_CODE = {
  ANDROID: 1,
  IOS: 2,
  WEB: 31,
  MWEB: 32,
  SMARTTV: 4,
  SAMSUNG: 41,
  LG: 42,
  SONY: 43,
  FOXSUM: 44,
  NETRANGE: 45,
  SKYWORTH: 46,
  OTHER: 49,
};

export function setDefaultValue(parameter) {
  var keyArray = [
    "vs-seq",
    "vs-vlen",
    "vs-wat",
    "vs-pos",
    "vs-cbr",
    "vs-cid",
    "vs-sst",
    "vs-wtd",
    "vs-nwtd",
  ];
  if (keyArray.indexOf(parameter) !== -1) {
    return 0;
  } else {
    return "und";
  }
}

export const BEACON_EXECUTE_TIME = {
  AllError: 30,
  AllVideoEnd: 30,
};

export const LAST_BEACON_SESSION_TIMER_CONFIG = {
  web: 1000,
  web_slow: 5000,
  mWeb: 2000,
  mWeb_slow: 3000,
};

export const CONNECTION_SPEED = {
  // max speed in Mb/s
  wifi_high: 100,
  wifi_med: 8,
  wifi_low: 3,
  wifi_low_slow: 1,
};

export const CONNECTION_SPEED_TYPE = {
  wifi: "100 Mbps - 1000 Mbps",
  "4g": "10 Mbps - 100 Mbps",
  "3g": "2 Mbps - 10 Mbps",
  "2g": "0 Mbps - 2 Mbps",
};

export const ANALYTICS_DEFAULT_PULSE_CONFIG = {
  maxPulseBeaconLimit: 3, //max count web - 3 ,tv - 5
  startAfterEventPulseBeacon: 1, //{1 - VideoSessionStart / 2 - Attempt / 3 - Ad Attempt / 4 - Ad Play / 5 - Ad Ended / 6 - Play}
  beaconTimeInterval: 1000, //web- 1 sec or tv - 2 sec
}; // time interval = web- 1 sec or tv - 2 sec

export const DEFAULT_PULSE_MAX_COUNT = {
  WEB: 3,
  TV: 5,
};

export const DEFAULT_PULSE_TIME_INTERVAL = {
  WEB: 1000,
  TV: 2000,
};

export const REMOVE_KEY_FOR_FOREIGN_COUNTRY = [
  EVENT_MAPPING.app_profile_id,
  EVENT_MAPPING.app_ppid,
  EVENT_MAPPING.app_sliv_profile_id,
  EVENT_MAPPING.app_user_age,
  EVENT_MAPPING.app_user_gender,
];
